module.exports = __webpack_public_path__ + "media/images/pub/vzvz_pub_xml-4d438d46b707b56d1c815a385297f050.png";